<template lang="pug">

    .fields(v-bind:class='classes')

        field(
            ref='fields'
            v-for='field in childrenFieldModels'
            v-bind:key='field.id'
            v-bind:field="field"
            v-bind:field-models="fieldModels"
            v-bind:value="value"
            v-on:input="updateValue($event)"
        )

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    import * as R from "ramda";

    export default {

        components: {
            field: () => import('@/components/products/forms/variant-forms/form/DynamicField')
        },

        computed: {

            childrenFieldModels() {
                const childrenLevel = this.field.id.split("-").length + 1

                return R.compose(

                    // Anhang von ID die Children-FieldModels finden
                    // > [ [ "form-1-1-1" ] ]
                    // < [ { id: "form-1-1-1" } ]
                    R.map(id => R.find(R.propEq("id", id), this.fieldModels)),

                    // ID wieder zusammensetzen
                    // > [ [ "form", "1", "1", "1" ] ]
                    // < [ [ "form-1-1-1" ] ]
                    R.map(R.join("-")),

                    // Nur IDs mit der Tiefe/des Levels fuer direkte Children filtern
                    // > [ [ "form", "1", "1" ], [ "form", "1", "1", "1" ] ]
                    // < [ [ "form", "1", "1", "1" ] ]
                    R.filter(splits => splits.length === childrenLevel),

                    // ID an "-" splitten
                    // > [ "form-1-1-1", "form-1-1-1" ]
                    // < [ [ "form", "1", "1" ], [ "form", "1", "1", "1" ] ]
                    R.map(R.split("-")),

                    // ID auslesen
                    // > [ { id: "form-1-1" }, { id: "form-1-1-1" } ]
                    // < [ "form-1-1", "form-1-1-1" ]
                    R.map(R.prop("id")),

                )(this.fieldModels)
            },

            classes() {
                const numberOfChildren = this.childrenFieldModels.length

                return {
                    two:   numberOfChildren === 2,
                    three: numberOfChildren === 3,
                    four:  numberOfChildren === 4
                }
            },

            $invalid() {
                R.forEach(field => field.$touch(), this.$refs.fields)

                return R.compose(

                    // > [ true, false ]
                    // > true
                    R.any(R.equals(true)),

                    // > [ { $invalid: true }, { $invalid: false } ]
                    // < [ true, false ]
                    R.map(R.prop('$invalid'))

                )(this.$refs.fields)
            }

        },

        methods: {
            updateValue(value) {
                this.$emit('input', value)
            }
        },

        props: {

            field: {
                type: Object,
                required: true
            },

            fieldModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

    }

</script>
